import React, { Component } from 'react';
import { Link } from 'react-router-dom'
import './test.css';
import { Form, Card, Button, Divider } from 'semantic-ui-react'
import axios from 'axios'

class login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: ''
    }

  }

  componentWillMount() {
    //console.log("MOUNTING")
  }

  getCookie = (name) => {
    var value = "; " + document.cookie;
    var parts = value.split("; " + name + "=");
    if (parts.length === 2) return parts.pop().split(";").shift();
  }

  componentDidMount() {
    var isAuth = false;
    var loggedIn = this.getCookie("loggedIn")
    var hasFailed = this.getCookie("hasFailed")

    if (loggedIn && !hasFailed) isAuth = true;
    /*if (tempCookie.substring(0, 8) === "loggedIn") {
      if (tempCookie.substring(9, 13) === "true") {
        isAuth = true
      } 
    }*/

    if (isAuth) document.location.href = "/test"
  }

  handleChange = (e, { name, value }) => this.setState({ [name]: value })

  submitLogin =() => {
    var countFail = this.getCookie("failureLoginAttempts")
    var d = new Date();
    d.setTime(d.getTime() + (2*24*60*60*1000));
    var expires = "expires=" + d.toUTCString();

    var dd = new Date();
    dd.setTime(dd.getTime() + (2*24*60*60*10));
    var failExpire = "expires=" + dd.toUTCString();

    if (countFail === undefined) countFail = 0
    countFail = parseInt(countFail,0) + 1
    if (countFail < 6) {
      axios.get('/api/login', {
        params: {
          id: this.state.email,
          pwd: this.state.password
        }
      })
      .then(function(res, err) {
        if (err) console.log(err);
        if (res.data[0] === "pass") {
          document.cookie = "loggedIn=true;" + expires
          document.cookie = "loggedInUser=" + res.data[1] + ";" + expires
          document.cookie = "loggedInId=" + res.data[2] + ";" + expires
          document.location.href = "/test"
        } else {
          if (res.data.length > 0) {
            if (res.data[1] === "inactive") {
              alert("User has been inactivated.")
            }
          }
          document.cookie = "failureLoginAttempts=" + countFail + ";" + failExpire
        }
      })
    } else {
      alert("Too many login attempts. Try again later.")
    }
  }

  render() {
    const { email } = this.state

    return (
      <div>
        <Card style={{margin: 'auto'}}>
          <Card.Content>
          <h2>Welcome!</h2>
            <Card.Header>
              Login to Continue
            </Card.Header>
            <Card.Description>
              <Form onSubmit={this.submitLogin}>
                <Form.Input label='Email Address' style={{marginBottom: '5px'}} name='email' value={email} onChange={this.handleChange} />
                <Button className="logSignButton" primary fluid type='submit' >Login</Button>
              </Form>
              <Divider horizontal>Or</Divider>
              <Link to="/signup"><Button className="logSignUpButton" secondary fluid >Sign Up</Button></Link>
            </Card.Description>
          </Card.Content>
        </Card>
        
      </div>
    );
  }
}

export default login;



// WEBPACK FOOTER //
// ./src/pages/login.js